import GenericRequest, { METHOD_GET } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class WorkerStateListTask extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.WORKERS_STATE);
    }

    overrideRequest() {}
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/list/worker-state-list/WorkerStateListTask.js